/*
 * @Author: nizhanjun
 * @Date:   2018-08-14 18:42:57
 * @Last Modified by:   nizhanjun
 * @Last Modified time: 2019-03-26 18:42:57
 */

// import './src/assets/styles/index.less'

// components
// base
import YYAvatar from './src/components/base/avatar/'
import YYButton from './src/components/base/button/'
import YYCollapse from './src/components/base/collapse/'
import YYEmpty from './src/components/base/empty/'
import YYIcon from './src/components/base/icon/'
import YYLoading from './src/components/base/loading/'
import { YYMenu, YYSubmenu, YYMenuItem } from './src/components/base/menu/'
import YYMessage from './src/components/base/message/'
import YYModal from './src/components/base/modal/'
import YYPage from './src/components/base/page/'
import { YYTabs } from './src/components/base/tabs/'
import { YYTabPane } from './src/components/base/tabs/'
import YYTip from './src/components/base/tip/'
// business
import { CountryCodeMobile, CountryCodeWeb } from './src/components/business/country-code/'
import YYSelectMember from './src/components/business/select-member/'
const components = {
    YYAvatar,
    YYButton,
    YYCollapse,
    YYEmpty,
    YYIcon,
    YYLoading,
    YYMenu,
    YYSubmenu,
    YYMenuItem,
    YYMessage,
    YYModal,
    YYPage,
    YYTabs,
    YYTabPane,
    YYTip,
    CountryCodeMobile,
    CountryCodeWeb,
    YYSelectMember
}

// directives
import clickoutside from './src/directives/clickoutside'
import transferDom from './src/directives/transfer-dom'
const directives = {
    clickoutside,
    transferDom,
}

// function
import {
    oneOf,
    typeOf,
    deepCopy,
    hasClass,
    addClass,
    removeClass,
    htmlEscape,
    escapeHtml
} from './src/utils/assist'
import md5 from './src/utils/md5'
import {
    getColor,
    getQuery,
    getCookie,
    getNavigatorLang,
    getMobileLang,
    getWebLang
} from './src/utils/utils'
import {
    locale
} from './src/locale'
const utils = {
    oneOf,
    typeOf,
    deepCopy,
    hasClass,
    addClass,
    removeClass,
    htmlEscape,
    escapeHtml,
    md5,
    getColor,
    getQuery,
    getCookie,
    getNavigatorLang,
    getMobileLang,
    getWebLang,
    locale
}

const install = function (Vue, opts = {}) {
    if (install.installed) return
    locale(opts && opts.locale || 'zhs')

    Object.keys(components).forEach(key => {
        Vue.component(key, components[key])
    })

    Object.keys(directives).forEach(key => {
        Vue.directive(key, directives[key])
    })

    Vue.prototype.$YYLoading = YYLoading
    Vue.prototype.$YYMessage = YYMessage
    Vue.prototype.$YYModal = YYModal
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

const YYZone = {
    ...components,
    ...directives,
    ...utils,
    install
}
module.exports.default = module.exports = YYZone


// WEBPACK FOOTER //
// ./index.js